// eslint-disable-next-line import/prefer-default-export
export const SET_DASHBOARD_LOOKUP_TYPES = 'SET DASHBOARD LOOKUP TYPES';
